import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { IAttendanceReports } from '../data/attendance-reports';
import { EvaluationDetailModalComponent } from './evaluation-detail-modal/evaluation-detail-modal.component';

@Component({
  selector: 'app-list-attendance-reports',
  templateUrl: './list-attendance-reports.component.html',
  styleUrls: ['./list-attendance-reports.component.scss']
})
export class ListAttendanceReportsComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() attendanceReports: IAttendanceReports[] = [];
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() mudouPagina = new EventEmitter<number>();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  // API do servidor retorna DateTime em UTC sem indicador de timezone
  // (ex.: "2026-02-10T17:00:00"). O parser nativo do JS trata strings ISO
  // sem "Z" como horário local, exibindo o valor UTC como se já fosse
  // horário de Brasília (defasagem de 3h). Normalizamos para UTC explícito
  // aqui e convertemos para horário de Brasília no template via DatePipe.
  BRAZIL_TIMEZONE_OFFSET = '-0300';

  constructor(private readonly dialog: MatDialog) {}

  toUtcDate(value: string | Date | undefined | null): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    const hasTimezoneInfo = /Z$|[+-]\d{2}:?\d{2}$/.test(value);
    return new Date(hasTimezoneInfo ? value : `${value}Z`);
  }

  // QueueEntryTime é DateTime não anulável no servidor: um registro legado sem valor
  // real chega como o padrão 0001-01-01T00:00:00, que é truthy e renderizaria
  // "01/01/0001" em vez de cair no fallback "Sem data".
  hasQueueEntryTime(report: IAttendanceReports): boolean {
    if (!report.queueEntryTime) {
      return false;
    }

    return (this.toUtcDate(report.queueEntryTime)?.getUTCFullYear() ?? 0) > 1;
  }

  openEvaluationModal(report: IAttendanceReports): void {
    if (!report.evaluationAnswers) return;
    this.dialog.open(EvaluationDetailModalComponent, {
      data: report.evaluationAnswers,
      width: '500px',
      maxHeight: '80vh'
    });
  }
}
